// src/components/admin/AdminApproveTeachersHeader.jsx
import React from "react";

const AdminApproveTeachersHeader = ({
  title = "אישור מורים",
  subtitle = "ניהול בקשות הצטרפות מורים: צפייה, סינון ואישור/דחייה",
  pendingCount = 0, // optional badge number
}) => {
  const hasPending = Number(pendingCount || 0) > 0;

  return (
    <section className="mx-auto max-w-7xl px-2 sm:px-4 md:px-6 lg:px-8 py-3" dir="rtl">
      <div className="relative overflow-hidden rounded-3xl">
        {/* soft gradient background */}
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 via-purple-25 to-blue-50" />

        {/* content card */}
        <div className="relative bg-white/80 backdrop-blur-xl border border-white/60 rounded-3xl p-6 shadow-2xl shadow-indigo-100/50">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-4 min-w-0">
              {/* icon block */}
              <div className="relative flex-shrink-0">
                <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 text-white flex items-center justify-center shadow-md">
                  <svg
                    viewBox="0 0 24 24"
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 2l7 4v6c0 5-3 9-7 10-4-1-7-5-7-10V6l7-4z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9.5 12.5l1.7 1.7 3.8-3.8"
                    />
                  </svg>
                </div>

                {/* pending badge */}
                {hasPending && (
                  <div className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center text-white text-xs font-bold animate-bounce">
                    {pendingCount}
                  </div>
                )}
              </div>

              {/* text */}
              <div className="min-w-0">
                <h1 className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-gray-900 via-indigo-800 to-purple-800 bg-clip-text text-transparent leading-tight">
                  {title}
                </h1>
                <p className="text-gray-600 mt-1 truncate">{subtitle}</p>
              </div>
            </div>

            {/* small hint chip (optional, consistent with the style) */}
            {hasPending && (
              <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-2xl bg-white/70 border border-white/60 text-sm font-bold text-amber-700">
                <span className="w-2 h-2 rounded-full bg-amber-500" />
                {pendingCount} ממתינים
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdminApproveTeachersHeader;
